export { default as Confirm } from "./confirm.vue";
export * from "./IConfirm";